<template>
  <b-modal
    id="automaticTranslation"
    :title="'Select languages for translation' | i18n"
    :ok-title="'Apply' | i18n"
    :cancel-title="'Cancel' | i18n"
    ok-variant="primary"
    :ok-disabled="!selectedTranslationLanguages.length"
    cancel-variant="outline-secondary"
    button-size="lg"
    size="lg"
    centered
    content-class="rounded-8"
    @ok="save"
    @show="init"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 mb-n4">
        <Multiselect
          :init-values="selectedTranslationLanguages"
          :options="languages"
          placeholder="Languages"
          placeholder-input="Select Language"
          :on-change="setSelectedTranslationLanguages"
          style="width: 100%"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from '../../../../common/multiselect';

import { TRANSLATE_LANGUAGE } from '../../../../../../../../../constants';

export default {
  name: 'AutomaticTranslation',
  components: { Multiselect },
  props: {
    selectedTranslationLanguages: {
      type: Array,
      default: () => [],
    },
    setSelectedTranslationLanguages: {
      type: Function,
      default: () => {},
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      languages: [],
      loaded: false,
    };
  },
  methods: {
    init() {
      this.languages = Object.keys(TRANSLATE_LANGUAGE).map((key) => ({ text: this.$translate(key), value: TRANSLATE_LANGUAGE[key] }));
    },
    save() {
      this.onSubmit(this.selectedTranslationLanguages);
    },
  },
};
</script>

<style scoped lang="scss">
.translate-actions {
  margin-bottom: 30px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-left: 15px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .modal-footer {
  justify-content: space-between;
  padding: 1.5rem;
  padding-top: 0;
  border: none;
  & > button {
    padding-right: 130px;
    padding-left: 130px;
    margin: 0;
  }
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
